export const convertHoursToSeconds = (hours: number) => {
  return hours * 60 * 60;
};

/**
 * Test an input value against min and/or max input values
 */
export const isValueInRange = (value: number, min?: number, max?: number) => {
  /**
   * NOTE: We check for `min === undefined` below b/c we want to allow
   * a value of zero for min
   */

  if (!max && min === undefined) {
    throw new Error("No 'min' or 'max' value provided!");
  }

  if (max && min === undefined) {
    return value <= max;
  }
  if (!max && min) {
    return value >= min;
  }

  // At this point, both min and max must be defined
  return value >= min! && value <= max!; // Using non-null assertion
};
